// check if element is visible
export const isElementVisibleUtil = (element) => {
    const style = getComputedStyle(element);
    return style.visibility !== "hidden" && style.display !== "none";
};
export default isElementVisibleUtil;
